import { Form } from "@unform/web";

import Button from "Components/Admin/Buttons";

import Question from "./Components/Question";
import * as S from "./styles";

const QuestionAnswerForm = ({
  selectedQuestion,
  answers,
  setSelectedQuestion,
}) => {
  return (
    <S.Wrapper>
      <S.Modal>
        <S.Section>
          <span>Resposta do Usuário</span>
          <hr />
        </S.Section>

        <Form>
          <Question
            key={selectedQuestion.id}
            question={selectedQuestion}
            answers={answers[selectedQuestion.id]}
          />
        </Form>

        <S.Buttons>
          <Button
            type="button"
            outline
            text="Fechar"
            onClick={() => setSelectedQuestion(null)}
          />
        </S.Buttons>
      </S.Modal>
    </S.Wrapper>
  );
};

export default QuestionAnswerForm;
